import { createStoreWithProducer } from '@xstate/store';
import { produce } from 'immer';

export type UploadProgressStoreContext = {
  isUploading: boolean;
  progress: number;
  currentFileName: string | null;
  appointmentId: string | null;
};

const defaultContext: UploadProgressStoreContext = {
  isUploading: false,
  progress: 0,
  currentFileName: null,
  appointmentId: null,
};

export const uploadProgressStore = createStoreWithProducer(
  produce,
  defaultContext,
  {
    setUploadProgress: (
      context,
      event: { progress: number; fileName?: string; appointmentId: string },
    ) => {
      context.isUploading = true;
      context.progress = event.progress;
      context.currentFileName = event.fileName ?? null;
      context.appointmentId = event.appointmentId;
    },
    clearUploadProgress: (context) => {
      context.isUploading = false;
      context.progress = 0;
      context.currentFileName = null;
      context.appointmentId = null;
    },
  },
);
